export enum NotificationDeliveryId {
  'PUSH' = 1,
  'TEXT',
  'EMAIL',
}

export interface INotificationDeliveryChannel {
  id?: number;
  notificationDeliveryId: NotificationDeliveryId;
  username: string;
  enabled: boolean;
}

export interface INotificationDeliveryFormat {
  text: INotificationDeliveryChannel;
  email: INotificationDeliveryChannel;
}
